import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import ContactForm from '../../views/contacts/ContactForm';
import { useAuthContext } from 'services/authentication/AuthenticationContext';

// The form to create a new ticket by a user
const TicketForm: React.FC<{ viewKey?: string, linkedItem?: { [key: string]: number } }> = ({ viewKey, linkedItem }) => {

    const { userDivision } = useAuthContext();
    const apiObject = 'ticket'

    // Plug in the fields and their properties
    const fields: FieldType[] = [
        {
            type: 'searchselect',
            name: 'reporter',
            label: 'ticket.general.reporter_label',
            placeholder: 'ticket.general.reporter_placeholder',
            objectName: 'contact.general.object_name.singular',
            query: {
                endpoint: 'get_contact_search',
                params: {
                    contact_type: ['contact', 'lead', 'client']
                }
            },
            selectionFormat: 'name',
            optionFormat: {
                title: { field: 'name', format: (value) => value },
                subtitle: { field: 'primary_location', format: (value) => value.address, optional: true },
            },
            addNewItem: { method: 'modal-form', modalForm: <ContactForm /> }
        },
        {
            type: 'textarea',
            name: 'description',
            label: 'ticket.general.description_label',
            placeholder: 'ticket.general.description_placeholder',
            rows: 4,
        },
        {
            type: 'dropdown',
            name: 'category',
            label: 'ticket.general.category_label',
            apiRequest: [{
                endpoint: 'get_ticket_category_list',
                object: 'ticket_category',
                params: { deleted: false, is_active: true },
            }],
            disabled_selected: 'ticket.general.category_placeholder',
            allowNoneOption: true,
            showSearch: false,
            optionFormat: 'name',
            selectionFormat: 'name',
        },
        {
            type: 'dropdown',
            name: 'division',
            label: 'ticket.general.division_label',
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
            }],
            activeFeature: 'divisions',
            defaultValue: userDivision ? { value: String(userDivision) } : undefined,
            disabled_selected: 'ticket.general.division_placeholder',
            allowNoneOption: false,
            showSearch: false,
            optionFormat: 'name',
            selectionFormat: 'name',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
            redirectTo={{ url: 'tickets', itemIdField: 'id' }}
        />
    );
};

export default TicketForm;
